import React from 'react';
import {
  Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Divider,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import TimelineIcon from '@mui/icons-material/Timeline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DescriptionIcon from '@mui/icons-material/Description';
import NotificationsIcon from '@mui/icons-material/Notifications';

const iconMap = {
  contact: <PeopleIcon color="primary" />, deal: <TimelineIcon color="success" />, task: <ScheduleIcon color="info" />, note: <DescriptionIcon color="secondary" />, notification: <NotificationsIcon color="warning" />,
};

export default function CrmRecentActivity({ activityData }) {
  return (
    <Paper sx={{ p: 3, mb: 2 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Recent Activity
      </Typography>
      <List>
        {activityData.slice(0, 10).map((item, idx) => (
          <React.Fragment key={idx}>
            <ListItem alignItems="flex-start">
              <ListItemIcon>{iconMap[item.type] || <TimelineIcon />}</ListItemIcon>
              <ListItemText
                primary={item.description}
                secondary={(
                  <>
                    <Typography component="span" variant="body2" color="text.primary">
                      {item.user}
                    </Typography>
                    {` — ${item.date}`}
                  </>
                )}
              />
            </ListItem>
            {idx < activityData.length - 1 && <Divider component="li" />}
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
}
